import { useState } from 'react'
import type { ImageAsset } from '../siteAssets'

interface SiteVisualProps {
  asset: ImageAsset
  className?: string
  aspectClassName?: string
}

export default function SiteVisual({
  asset,
  className = '',
  aspectClassName = 'aspect-[4/3]',
}: SiteVisualProps) {
  const [failed, setFailed] = useState(false)

  return (
    <div className={`panel-surface overflow-hidden ${className}`}>
      {failed ? (
        <div className={`${aspectClassName} flex flex-col justify-between bg-[linear-gradient(180deg,rgba(255,255,255,0.06),rgba(255,255,255,0.02))] p-8`}>
          <div>
            <p className="text-xs uppercase tracking-[0.24em] text-copper-light">Image Slot</p>
            <p className="mt-4 text-2xl font-display leading-tight text-birch">{asset.title}</p>
          </div>
          <div>
            <p className="text-sm leading-6 text-weathered">{asset.description}</p>
            <p className="mt-4 text-xs uppercase tracking-[0.18em] text-weathered/80">{asset.src}</p>
          </div>
        </div>
      ) : (
        <img
          src={asset.src}
          alt={asset.alt}
          className={`h-full w-full object-cover ${aspectClassName}`}
          loading="lazy"
          onError={() => setFailed(true)}
        />
      )}
    </div>
  )
}
